var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.additionalParameters.length > 0
    ? _c(
        "div",
        [
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("travelService.additionalParametersList")) + ":"
            )
          ]),
          _c(
            "v-row",
            _vm._l(_vm.additionalParameters, function(additionalParameter) {
              return _c(
                "v-col",
                {
                  key: additionalParameter.ordinate,
                  staticClass: "pa-2",
                  attrs: { cols: "4" }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: additionalParameter.name,
                      readonly: "",
                      filled: "",
                      value: additionalParameter.value
                    }
                  })
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }